import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  reduxForm
} from 'redux-form';
import {
  BackToSignInButton,
  ErrorMessage,
  SubmitButton,
  TextField
} from '../components';

const validate = values => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }

  return errors
};

const RequestNewPasswordForm = ({
  handleSubmit,
  changeState,
  errorMessage = false,
  working = false
}) => {
  return (
    <form
      className="forgot-password auth__form"
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <div className="auth--form-group">
        <Field
          name="email"
          component={TextField}
          label="Email"
          type="email"
          props={{
            disabled: working
          }}
        />
      </div>
      <SubmitButton
        busy={working}
        textOnBusy="Requesting Password"
        textOnIdle="Request Password"
      />
      <ErrorMessage errorMessage={errorMessage} />
      <BackToSignInButton changeState={changeState} />
    </form>
  )
};

RequestNewPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  changeState: PropTypes.func.isRequired,
  errorMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]).isRequired,
  working: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'auth/forgot-password/request',
  validate
})(RequestNewPasswordForm);


// WEBPACK FOOTER //
// ./src/components/Authentication/ForgotPassword/RequestNewPasswordForm.js